<template>
  <div style="background-color: #f5f5f5">
    <NavbarLanding />
    <v-container class="py-6">
      <v-row justify="center">
        <v-col cols="12" md="10" class="px-4">
          <h1>Termos de Uso e Serviço - Parque das Recordações</h1>
          <p><strong>Última atualização:</strong> 05 de agosto de 2025</p>
          <p>
            Bem-vindo ao Portal Parque das Recordações. Ao acessar e utilizar
            nossos serviços, você declara ciência e concordância integral com os
            termos descritos abaixo e com nossa Política de Privacidade.
          </p>

          <h3>1. Nossos Serviços:</h3>
          <p>
            O Portal, operado pelo Grupo Parque das Flores, oferece uma
            plataforma digital para a realização de cerimônias de despedida,
            disponibilizando gratuitamente os seguintes serviços:
          </p>
          <ul>
            <li>Transmissão ao vivo de cerimônias com áudio e vídeo.</li>
            <li>
              Sistema para envio de mensagens de condolências, que ficam
              sujeitas à aprovação de um Moderador.
            </li>
          </ul>

          <h3>
            2. Suas Responsabilidades como Usuário Responsável - Moderador:
          </h3>
          <ul>
            <li>
              A criação de uma página de despedida designa um Usuário
              Responsável - Moderador, que declara possuir todas as autorizações
              necessárias para a transmissão da cerimônia.
            </li>
            <li>
              Este Moderador é integralmente responsável por todo o conteúdo
              transmitido (imagens, áudio, falas), bem como pelo controle de
              privacidade da página e pela moderação das mensagens enviadas por
              visitantes.
            </li>
            <li>
              O Portal Parque das Recordações atua exclusivamente como provedor
              técnico da infraestrutura, não exercendo controle editorial sobre
              o conteúdo transmitido.
            </li>
          </ul>

          <h3>3. Privacidade e Proteção de Dados</h3>
          <ul>
            <li>
              O tratamento de dados pessoais realizado pela plataforma segue
              rigorosamente as diretrizes da Lei Geral de Proteção de Dados
              (LGPD - Lei nº 13.709/2018).
            </li>
            <li>
              Todos os dados são manuseados com rigor técnico e ético,
              protegidos por protocolos de segurança e armazenados em servidores
              seguros localizados no Brasil. Para mais detalhes, consulte nossa
              Política de Privacidade.
            </li>
          </ul>

          <h3>4. Conduta dos Visitantes</h3>
          <p>
            As mensagens de condolências não devem conter linguagem ofensiva,
            caluniosa, discriminatória ou ilegal, sob pena de não aprovação pelo
            Moderador.
          </p>

          <h3>5. Violação dos Termos</h3>
          <p>
            O Grupo Parque das Flores reserva-se o direito de suspender ou
            remover qualquer transmissão que viole estes termos, receba denúncia
            fundamentada ou seja objeto de ordem judicial.
          </p>
        </v-col>
      </v-row>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import Footer from "../landingpage/Footer.vue";
import NavbarLanding from "../landingpage/Navbar.vue";

export default {
  name: "TermosDeUso",
  components: {
    NavbarLanding,
    Footer,
  },
};
</script>

<style scoped>
/* Typography */
h1 {
  font-size: 2.2rem !important;
  font-weight: 700;
  color: #343f53;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  border-bottom: 3px solid #343f53;
  padding-bottom: 1rem;
}

h3 {
  font-size: 1.2rem !important;
  font-weight: 600;
  color: #2d3748;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
  position: relative;
}

h3::before {
  content: "";
  position: absolute;
  left: -1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: linear-gradient(135deg, #343f53 0%, #a0a8b8 80%);
  border-radius: 2px;
}

p {
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.7;
  color: #4a5568;
}

p strong {
  color: #2d3748;
  font-weight: 600;
}

/* Lists */
ul {
  margin: 1rem 0 1.5rem 0;
  padding-left: 0;
}

li {
  list-style: none;
  position: relative;
  padding: 0.5rem 0 0.5rem 2rem;
  font-size: 1rem;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 0.5rem;
}

li::before {
  content: "•";
  position: absolute;
  left: 0.5rem;
  color: #343f53;
  font-weight: bold;
  font-size: 1.2rem;
}

/* Content styling */
.v-col {
  background: white;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

@media (max-width: 767px) {
  h1 {
    font-size: 1.2rem !important;
  }

  h3 {
    font-size: 1rem !important;
  }

  .v-col {
    padding: 1.5rem;
    margin: 0 10px;
  }
}
</style>
